import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { companySelectorCreator, getCompany } from "Bands/state";
import { API_ENDPOINTS } from "shared/constants";
import { getIdFromPath } from "shared/utils";

export const useFetchCompany = (companyPath: string) => {
  const dispatch = useDispatch();

  const companyId = useMemo(
    () => getIdFromPath(companyPath, API_ENDPOINTS.COMPANIES),
    [companyPath]
  );

  const companyIdSelector = useMemo(
    () => companySelectorCreator(companyId),
    [companyId]
  );

  const company = useSelector(companyIdSelector);

  // fetch company
  useEffect(() => {
    dispatch(getCompany(companyId));
  }, [companyId, dispatch]);

  return { company };
};
